import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultNamedParentedPersistableResource,
    NamedParentedPersistableResourceSchema,
} from '../../../resource-base/persistableResourceTypes';

export enum ProjectUserRolePropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    IS_MANAGER = 'IS_MANAGER',
    IS_PROCESS_ADMIN = 'IS_PROCESS_ADMIN',
    IS_READER = 'IS_READER',
}

export const ProjectUserRoleResourceSchema = NamedParentedPersistableResourceSchema.extend({
    description: z.string(),
    isProcessAdmin: z.boolean(),
    isManager: z.boolean(),
    isReader: z.boolean(),
    resourceType: z.literal(ResourceType.PROJECT_USER_ROLE).default(ResourceType.PROJECT_USER_ROLE),
});

export const ProjectUserRoleMutationResourceSchema = getMutationSchema(ProjectUserRoleResourceSchema);

export type ProjectUserRoleResource = z.infer<typeof ProjectUserRoleResourceSchema>;

export const defaultProjectUserRoleResource: ProjectUserRoleResource = {
    ...defaultNamedParentedPersistableResource,
    resourceType: ResourceType.PROJECT_USER_ROLE,
    description: '',
    isProcessAdmin: false,
    isManager: false,
    isReader: false,
};

export function useProjectUserRoleActions() {
    return useMultiResourceSingleParentedResourceAdapterActions(
        'project-user-role',
        ResourceType.PROJECT_USER_ROLE,
        ProjectUserRoleResourceSchema
    );
}
